import { Parser } from "@siteimprove/alfa-parser";
import { Err, Result } from "@siteimprove/alfa-result";
import { Token } from "../../../../syntax/index.js";
import { Keyword } from "../../../textual/keyword.js";
import { Value } from "../../../value.js";
const { map } = Parser;
/**
 * @internal
 */
export class Extent extends Value {
    static of(shape = Extent.Shape.Circle, size = Extent.Size.FarthestCorner) {
        return new Extent(shape, size);
    }
    _shape;
    _size;
    constructor(shape, size) {
        super("extent", false);
        this._shape = shape;
        this._size = size;
    }
    get shape() {
        return this._shape;
    }
    get size() {
        return this._size;
    }
    resolve() {
        return this;
    }
    equals(value) {
        return (value instanceof Extent &&
            value._shape === this._shape &&
            value._size === this._size);
    }
    hash(hash) {
        hash.writeString(this._shape).writeString(this._size);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            shape: this._shape,
            size: this._size,
        };
    }
    toString() {
        return `${this._shape} ${this._size}`;
    }
}
/**
 * @internal
 */
(function (Extent) {
    let Shape;
    (function (Shape) {
        Shape["Circle"] = "circle";
        Shape["Ellipse"] = "ellipse";
    })(Shape = Extent.Shape || (Extent.Shape = {}));
    let Size;
    (function (Size) {
        Size["ClosestSide"] = "closest-side";
        Size["FarthestSide"] = "farthest-side";
        Size["ClosestCorner"] = "closest-corner";
        Size["FarthestCorner"] = "farthest-corner";
    })(Size = Extent.Size || (Extent.Size = {}));
    const parseShape = map(Keyword.parse("circle", "ellipse"), (keyword) => keyword.value);
    const parseSize = map(Keyword.parse("closest-side", "farthest-side", "closest-corner", "farthest-corner"), (keyword) => keyword.value);
    Extent.parse = (input) => {
        let shape;
        let size;
        while (true) {
            for ([input] of Token.parseWhitespace(input)) {
            }
            if (shape === undefined) {
                const result = parseShape(input);
                if (result.isOk()) {
                    [input, shape] = result.get();
                    continue;
                }
            }
            if (size === undefined) {
                const result = parseSize(input);
                if (result.isOk()) {
                    [input, size] = result.get();
                    continue;
                }
            }
            break;
        }
        if (shape === undefined && size === undefined) {
            return Err.of(`Expected either an extent shape or size`);
        }
        return Result.of([input, Extent.of(shape, size)]);
    };
})(Extent || (Extent = {}));
//# sourceMappingURL=extent.js.map